export default __webpack_public_path__ + "static/media/down-arrow.76d14f35.svg";